<template>
  <footer class="footer">
    <div class="scroll-top">
      <a href="#" @click.prevent="scrollToTop">بازگشت به بالا</a>
    </div>
    <div class="social-links">
      <a href="tel:04133826195"><i class="fas fa-phone-alt"></i></a>
      <a href="https://www.instagram.com/pardis.consulting.engineers?igsh=MTV6aTZidm80c25rYg==" target="_blank"><i class="fab fa-instagram"></i></a>
      <a href="https://telegram.me/+989932010538" target="_blank"><i class="fab fa-telegram"></i></a>
      <a href="https://wa.me/+989932010538" target="_blank"><i class="fab fa-whatsapp"></i></a>

      <a href="https://www.pas90.ir/" target="_blank"><i class="fas fa-globe"></i></a>
    </div>
    <p class="footer-text">پردیس آمایش سرزمین <br>سازمان اقتصادی و سرمایه گذاری</p>
    <div class="legal">
      <p>&copy; 2024 Pardis amayesh sarzamin. All rights reserved.</p> 
      <p>Designed and Developed by <a href="https://hemo-cvportfolio.com">HeMo</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
a {
  color: #2f2f2f62; /* Inherit color from parent element */
  text-decoration: none; /* Remove underline */
}

a:hover {
  text-decoration: underline; /* Add underline on hover */
}
.legal{
  color: #3c3c3c46; /* Changed text color to black */
}
.footer {
  background-color: #fff; /* Changed to white background */
  color: #000; /* Changed text color to black */
  padding: 40px; /* Increased padding */
  padding-top: 100px;;
  text-align: center;
}

.social-links {
  display: flex;
  justify-content: center; /* Center the icons horizontally */
  align-items: center;
}

.social-links a {
  margin: 0 10px; /* Added margin between icons */
  color: #000; /* Changed link color to black */
  font-size: 24px;
  text-decoration: none; /* Remove underline */
  transition: opacity 0.3s; /* Added transition for opacity */
}

.social-links a:hover {
  opacity: 0.7; /* Reduced opacity on hover */
}

.scroll-top {
  margin-bottom: 20px; /* Added margin to separate "Scroll to top" link from social links */
}

.scroll-top a {
  color: #000; /* Changed link color to black */
  font-size: 18px;
  text-decoration: none; /* Remove underline */
  transition: opacity 0.3s; /* Added transition for opacity */
}

.scroll-top a:hover {
  opacity: 0.7; /* Reduced opacity on hover */
}

.footer-text {
  margin-top: 20px; /* Increased margin */
  line-height: 30px;
  font-size: 22px;
}
</style>
